import moment from 'moment';

export const getVersion = (): string => {
    return "0.0.2";
};

export function encodeBase64(input: string) {
    return btoa(unescape(encodeURIComponent(input)));
}

export function decodeBase64(input: string) {
    return decodeURIComponent(escape(atob(input)));
}

export const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
export const isValidUsername = (username: string) => {
    //8-32 alpha number - _
    return /^[a-zA-Z0-9_-]+$/.test(username)
}

export const deepMerge = (target: any, source: any): any => {
    for (const key in source) {
        if (source[key] instanceof Object && key in target) {
            target[key] = deepMerge(target[key], source[key]);
        } else {
            target[key] = source[key];
        }
    }
    return target;
};

export function truncateAddress(address: string, startLen = 4, endLen = 4): string {
    if (address.length <= startLen + endLen) {
        return address;
    }
    const start = address.slice(0, startLen);
    const end = address.slice(-endLen);
    return `${start}...${end}`;
}


export function firstUpperCase(str: string): string {
    return str.toString()[0].toUpperCase() + str.toString().slice(1);
}

export function getAppClientId() {
    return "react-sdk-" + getVersion()
}


function convertScientificToDecimal(num: number) {
    let str = num.toFixed(12)
    str = str.replace(/0+$/, '')
    str = str.replace(/\.$/, '')
    return str
}

interface NumberFormatterProps {
    value: number | string | undefined
    prefix?: string
    suffix?: string
    separator?: boolean
    fixNum?: number //number >= 1 fix num
    tFixNum?: number //number < 1 fix num
    intClassName?: string
    decimalClassName?: string
    prefixClassName?: string
    className?: string
}

export const NumberFormatter: React.FC<NumberFormatterProps> = ({
                                                                    value,
                                                                    prefix = '',
                                                                    suffix = '',
                                                                    separator = true,
                                                                    fixNum = 2,
                                                                    tFixNum = 4,
                                                                    intClassName = "",
                                                                    decimalClassName = "",
                                                                    prefixClassName = "",
                                                                    className = ""
                                                                }) => {
    const numberValue =
        typeof value === 'number'
            ? convertScientificToDecimal(value)
            : value
                ? value
                : '0'

    const [intPart, decimalPart] = numberValue.toString().split('.')

    const intFormat = separator
        ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : intPart

    if (Math.abs(parseFloat(numberValue)) >= 1) {
        return (
            <span className={className}>
            {prefix && <span className={prefixClassName}>{prefix}</span>}
                <span className={intClassName}>{intFormat}</span>
                {decimalPart ? (
                    <span className={decimalClassName}>
            .{decimalPart.substring(0, fixNum)}
            </span>
                ) : (
                    ''
                )}
                {suffix}
        </span>
        )
    }

    if (decimalPart) {
        let zeroCount = 0
        for (let i = 0; i < decimalPart.length; i++) {
            if (decimalPart[i] === '0') {
                zeroCount++
            } else {
                break
            }
        }
        if (zeroCount < tFixNum) {
            return (
                <span className={className}>
                        {prefix && <span className={prefixClassName}>{prefix}</span>}
                    <span className={intClassName}>{intFormat}</span>
                    <span className={decimalClassName}>
            .{decimalPart.substring(0, tFixNum)}
                </span>
                    {suffix}
                </span>
            )
        }
        return (
            <span className={className}>
                        {prefix && <span className={prefixClassName}>{prefix}</span>}
                <span className={intClassName}>{intFormat}</span>
                    <span className={decimalClassName}>
                    .0<sub>{zeroCount}</sub>
                        {decimalPart?.substring(zeroCount, zeroCount + tFixNum - 2)}
                </span>
                {suffix}
                </span>
        )
    }
    return (
        <span className={className}>
                    {prefix && <span className={prefixClassName}>{prefix}</span>}
            <span className={intClassName}>{intPart}</span>
            {suffix}
                </span>
    )
}

export function formatAddress(address: string, pre = 4, after = 5) {
    return `${address.substring(0, pre)}...${address.substring(address.length - after, address.length)}`
}

export const formatDate = (value: any, formatString = 'YYYY-MM-DD HH:mm:ss') => {
    if (value) {
        return moment.unix(value).format(formatString)
    }
    return '--'
}
export const isInTgApp = () => {
    return !!(window.TelegramWebviewProxy)
}

export function bytesToBase64(bytes: Uint8Array) {
    const binString = String.fromCodePoint(...bytes);
    return btoa(binString);
}